import { createSelector } from '@ngrx/store';

import { cloneDeep as _cloneDeep } from 'lodash-es';

import { ListEntry } from '@data/list-entry';
import { PCache } from '@data/pcache';

import { OrderFilterState, OrderModifyFormDataState, fdOrderModifyFormDataAdapter, fltOrderFilterAdapter } from './pcache.reducers';

export const selectPCacheState = (state) => state.pcache;
export const selectOrderFilterEntities = (state) => state.pcache.fltOrderFilters as OrderFilterState;
export const selectOrderModifyFormDataEntities = (state) => state.pcache.fdOrderModify as OrderModifyFormDataState;

export const selectInvSumColPref = createSelector(selectPCacheState, (state) => state.cpInventorySummary);

export const selectInvDtlColPref = createSelector(selectPCacheState, (state) => state.cpInventoryDetail);

export const selectInvLotColPref = createSelector(selectPCacheState, (state) => state.cpInventoryLot);

export const selectOrdInqColPref = createSelector(selectPCacheState, (state) => state.cpOrderInquiry);

export const selectOrdDtlColPref = createSelector(selectPCacheState, (state) => state.cpOrderDetails);

export const selectOrdModDtlColPref = createSelector(selectPCacheState, (state) => state.cpOrderModifyDetails);

export const selectReportListColPref = createSelector(selectPCacheState, (state) => state.cpReportList);

export const selectUserLookupColPref = createSelector(selectPCacheState, (state) => state.cpUserLookup);

export const selectOrderFilterById = (list: string) =>
  createSelector(selectOrderFilterEntities, (listState) => (listState.entities ? listState.entities[list] : ({} as ListEntry)));

export const selectOrderModifyFormDataById = (id: string) =>
  createSelector(selectOrderModifyFormDataEntities, (state) => (state.entities ? _cloneDeep(state.entities[id]) : ({} as PCache)));

export const orderFilterSelectors = fltOrderFilterAdapter.getSelectors(selectOrderFilterEntities);
export const orderModifyFormDataSelectors = fdOrderModifyFormDataAdapter.getSelectors(selectOrderModifyFormDataEntities);
